// @flow
import MyStore from './MyStore';
import { connect } from 'react-redux';
import { compose } from 'recompose';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(MyStore);